import React from 'react';
import { PreviewContent } from '../../../../styles/TradeDocStyles';
import { REACT_APP_BASE_URL } from '../../../../config';
import DocumentViewer from '../../../DocumentViewer/DocumentViewer';
import { Stack } from '@mui/material';
import moment from 'moment';
import { formatCurrency, formatNumber } from '../../../../utils/helper';
import { TransformedItems } from '../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';

const FormPreviewMobileTemplate = ({
    data,
    docTitle,
    quoteFields,
    totalAmount,
    signatureUrlBase64,
    totalGrossWeight,
    totalUnitQuantity,
    totalNetWeight,
    signatureUrlBase64Chamber,
    totalVolume
}: {
    data: any;
    docTitle: string;
    quoteFields: TransformedItems[];
    totalAmount?: number;
    signatureUrlBase64: string;
    totalGrossWeight?: number;
    totalUnitQuantity?: number;
    totalNetWeight?: number;
    signatureUrlBase64Chamber?: string;
    totalVolume?: number;
}) => {
    return (
        <PreviewContent style={{ padding: '25px 0' }}>
            <div className='flex items-center justify-start pb-4 mb-4 border-b'>
                {data?.logoUrl ? (
                    <div className='h-[4rem] w-[100%] '>
                        <DocumentViewer
                            fileUrl={`${REACT_APP_BASE_URL}/${data?.logoUrl.split(
                                '/v1/'
                            )[1]}`}
                        />
                    </div>
                ) : (
                    <>
                        <div>
                            <img
                                src='/img/vectors/powered.svg'
                                alt=''
                                className=' h-[50px]'
                            />
                        </div>
                    </>
                )}
            </div>

            {(docTitle === 'Commercial Invoice' ||
                docTitle === 'Packing List' ||
                docTitle === 'Draft Certificate of Origin') && (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='top-preview-content'
                    width='full'
                    gap={2}
                    justifyContent={'space-between'}
                >
                    <div
                        className='view-one w-full'
                        style={{ maxWidth: '100%' }}
                    >
                        <p className='font-semibold text-appcolorprimary'>
                            Exporter
                        </p>
                        <p className='font-medium'>
                            {data?.exporterName || '--'}
                        </p>
                        <p>{data?.exporterAddress}</p>
                        <p>{data?.exporterCountry}</p>
                    </div>
                    <div
                        className='view-two border-b pb-4'
                        style={{ maxWidth: '100%' }}
                    >
                        <p className='font-semibold text-appcolorprimary'>
                            Consignee
                        </p>
                        <p className='font-medium'>{data?.consigneeName}</p>
                        <p>{data?.consigneeAddress}</p>
                        <p>{data?.consigneeCountry}</p>
                    </div>

                    <div className='view-three' style={{ maxWidth: '100%' }}>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Invoice No.</p>
                            {docTitle === 'Draft Certificate of Origin' ||
                            docTitle === 'Packing List' ? (
                                <p className='value'>
                                    {data?.exportInvoiceNumber || '--'}
                                </p>
                            ) : (
                                <p className='value'>
                                    {data?.invoiceNumber || '--'}
                                </p>
                            )}
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>
                                {docTitle === 'Draft Certificate of Origin'
                                    ? 'Exporter Invoice Date'
                                    : 'Date'}
                            </p>
                            <p className='value'>
                                {moment(
                                    docTitle === 'Draft Certificate of Origin'
                                        ? data?.exportInvoiceDate
                                        : data?.exportInvoiceDate
                                ).format('ll') || '--'}
                            </p>
                        </Stack>

                        {docTitle !== 'Draft Certificate of Origin' && (
                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className='title'>Reference</p>
                                <p className='value'>
                                    {data?.reference || '--'}
                                </p>
                            </Stack>
                        )}
                        {docTitle === 'Draft Certificate of Origin' && (
                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className='title'>Letter of Credit Number</p>
                                <p className='value'>
                                    {data?.letterOfCreditNumber || '--'}
                                </p>
                            </Stack>
                        )}
                        {data?.buyerName && (
                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className='title'>Buyer Name</p>
                                <p className='value'>
                                    {docTitle === 'Draft Certificate of Origin'
                                        ? data?.buyerName
                                        : data?.buyer || '--'}
                                </p>
                            </Stack>
                        )}
                        {data?.buyerAddress && (
                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className='title'>Buyer Address</p>
                                <p className='value'>
                                    {data?.buyerAddress || '--'}
                                </p>
                            </Stack>
                        )}
                        {docTitle === 'Commercial Invoice' &&
                            data?.buyerReference && (
                                <Stack
                                    direction='row'
                                    gap='20px'
                                    width='100%'
                                    justifyContent='space-between'
                                >
                                    <p className='title'>Buyer Reference</p>
                                    <p className='value'>
                                        {data?.buyerReference || '--'}
                                    </p>
                                </Stack>
                            )}
                        {docTitle === 'Packing List' && (
                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className='title'>Bill of Lading Number</p>
                                <p className='value'>
                                    {data?.billOfLadingNumber || '--'}
                                </p>
                            </Stack>
                        )}
                    </div>
                </Stack>
            )}

            {docTitle === 'Commercial Invoice' && (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='mid-preview-content border-b pb-4'
                    width='full'
                    justifyContent={'space-between'}
                >
                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Method of Dispatch</p>
                            <p className='value'>{data?.methodOfDispatch}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Type of Shipment</p>
                            <p className='value'>{data?.typeOfShipment}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Country Of Origin of Goods</p>
                            <p className='value'>{data?.countryOfOriginName}</p>
                        </div>
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Transport</p>
                            <p className='value'>{data?.transport}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Voyage Number</p>
                            <p className='value'>{data?.voyageNumber}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Final Destination</p>
                            <p className='value'>{data?.countryOfOriginName}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>
                                Country of Final Destination
                            </p>
                            <p className='value'>
                                {data?.countryOfFinalDestinationName}
                            </p>
                        </div>
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Port of Loading</p>
                            <p className='value'>
                                {data?.portOfLoadingValue?.name}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Method of Discharge</p>
                            <p className='value'>
                                {data?.portOfDischargeValue?.name}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Method of Dispatch</p>
                            <p className='value'>{data?.methodOfDispatch}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Place of Origin</p>
                            <p className='value'>{data?.placeOfOrigin}</p>
                        </div>
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Date of Departure</p>
                            <p className='value'>
                                {moment(data?.dateOfDeparture).format('ll')}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Terms/Method of Payment</p>
                            <p className='value'>{data?.termsOfPayment}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Marine Cover Policy No</p>
                            <p className='value'>{data?.marineCoverPolicyNo}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Letter Of Credit No</p>
                            <p className='value'>{data?.letterOfCreditNo}</p>
                        </div>
                    </div>
                </Stack>
            )}

            {docTitle === 'Packing List' && (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='mid-preview-content'
                    width='full'
                    justifyContent={'space-between'}
                >
                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Method of Dispatch</p>
                            <p className='value'>
                                {data?.methodOfDispatch || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Type of Shipment</p>
                            <p className='value'>
                                {data?.typeOfShipment || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Country Of Origin of Goods</p>
                            <p className='value'>
                                {data?.countryOfOriginName || '--'}
                            </p>
                        </div>
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Transport</p>
                            <p className='value'>{data?.transport || '--'}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Voyage Number</p>
                            <p className='value'>
                                {data?.voyageNumber || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>
                                Country of Final Destination
                            </p>
                            <p className='value'>
                                {data?.countryOfFinalDestinationName || '--'}
                            </p>
                        </div>
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Place of Origin</p>
                            <p className='value'>
                                {data?.placeOfOrigin || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Method of Discharge</p>
                            <p className='value'>
                                {data?.portOfDischargeValue?.name || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Final Destination</p>
                            <p className='value'>
                                {data?.finalDestination || '--'}
                            </p>
                        </div>{' '}
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Port of Loading</p>
                            <p className='value'>
                                {data?.portOfLoadingValue?.name || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Date of Departure</p>
                            <p className='value'>
                                {moment(data?.dateOfDeparture).format('ll')}
                            </p>
                        </div>
                    </div>
                </Stack>
            )}

            {docTitle === 'Draft Certificate of Origin' && (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='mid-preview-content'
                    width='full'
                    justifyContent={'space-between'}
                >
                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Method of Dispatch</p>
                            <p className='value'>
                                {data?.methodOfDispatch || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Type of Shipment</p>
                            <p className='value'>
                                {data?.typeOfShipment || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Port of Loading</p>
                            <p className='value'>
                                {data?.portOfLoadingValue?.name || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Date of Departure</p>
                            <p className='value'>
                                {moment(data?.dateOfDeparture).format('ll')}
                            </p>
                        </div>
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Transport</p>
                            <p className='value'>{data?.transport || '--'}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Voyage Number</p>
                            <p className='value'>
                                {data?.voyageNumber || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Method of Discharge</p>
                            <p className='value'>
                                {data?.portOfDischargeValue?.name || '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Final Destination</p>
                            <p className='value'>
                                {data?.finalDestination || '--'}
                            </p>
                        </div>
                    </div>

                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Parking Details</p>
                            <p className='value'>
                                {data?.packingDetails || '--'}
                            </p>
                        </div>
                    </div>
                </Stack>
            )}

            {docTitle === 'Commercial Invoice' &&
                quoteFields?.map((item: any) => (
                    <Stack
                        direction='column'
                        alignItems='start'
                        className='mid-preview-content mt-0 border-t border-dashed bg-aliceBlue'
                        width='full'
                        justifyContent={'space-between'}
                        style={{
                            borderTop: 0,
                            marginBottom: 0,
                            borderStyle: 'dashed'
                        }}
                    >
                        <div className='view-one' style={{ maxWidth: '100%' }}>
                            <div className='flex justify-between'>
                                <p className='title'>Product Code</p>
                                <p className='value'>{item.id ?? '--'}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Description of Goods</p>
                                <p className='value'>{item.desc ?? '--'}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Unit Quantity </p>
                                <p className='value'>
                                    {formatNumber(item.qty ?? 0)}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Unit Type </p>
                                <p className='value'>{item.type}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Unit Price </p>
                                <p className='value'>
                                    {formatCurrency(
                                        item.price ?? 0,
                                        item.currencyCode
                                    )}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Total </p>
                                <p className='value'>
                                    {formatCurrency(
                                        (isNaN(item.price) ? 0 : item.price) *
                                            (isNaN(item.qty) ? 0 : item.qty),
                                        data?.currencyCode
                                    )}
                                </p>
                            </div>
                        </div>
                    </Stack>
                ))}

            {docTitle === 'Packing List' &&
                quoteFields?.map((item: any) => (
                    <Stack
                        direction='column'
                        alignItems='start'
                        className='mid-preview-content mt-0 border-t border-dashed bg-aliceBlue'
                        width='full'
                        justifyContent={'space-between'}
                        style={{
                            borderStyle: 'dashed',
                            marginBottom: 0,
                            marginTop: 0
                        }}
                    >
                        <div className='view-one' style={{ maxWidth: '100%' }}>
                            <div className='flex justify-between'>
                                <p className='title'>Product Code</p>
                                <p className='value'>{item.id ?? '--'}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Description of Goods</p>
                                <p className='value'>{item.desc ?? '--'}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Quantity </p>
                                <p className='value'>
                                    {formatNumber(item.qty ?? 0)}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Package Kind </p>
                                <p className='value'>
                                    {item.kindOfPackage ?? '--'}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Package Quantity </p>
                                <p className='value'>
                                    {formatNumber(item.qtyOfPackage ?? 0)}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>
                                    Net Weight of Package (Kg){' '}
                                </p>
                                <p className='value'>
                                    {formatNumber(item.weightOfPackageKG ?? 0)}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>
                                    Gross Weight of Package (Kg){' '}
                                </p>
                                <p className='value'>
                                    {formatNumber(
                                        item.grossWeightOfPackageKG ?? 0
                                    )}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>
                                    Measurements of Package (m3)
                                </p>
                                <p className='value'>
                                    {formatNumber(
                                        item.measurementOfPackage ?? 0
                                    )}
                                </p>
                            </div>
                        </div>
                    </Stack>
                ))}

            {docTitle === 'Draft Certificate of Origin' &&
                quoteFields?.map((item: any) => (
                    <Stack
                        direction='column'
                        alignItems='start'
                        className='mid-preview-content mt-0 border-t border-dashed bg-aliceBlue'
                        width='full'
                        justifyContent={'space-between'}
                        style={{
                            borderStyle: 'dashed',
                            marginBottom: 0,
                            marginTop: 0
                        }}
                    >
                        <div className='view-one' style={{ maxWidth: '100%' }}>
                            <div className='flex justify-between'>
                                <p className='title'>Marks & Numbers*</p>
                                <p className='value'>{item.id ?? '--'}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Description of Goods</p>
                                <p className='value'>{item.desc ?? '--'}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Package Kind </p>
                                <p className='value'>
                                    {item.kindOfPackage ?? '--'}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Package Quantity </p>
                                <p className='value'>
                                    {formatNumber(item.qtyOfPackage ?? 0)}
                                </p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='title'>Tariff Code </p>
                                <p className='value'>
                                    {item.tariffCode ?? '--'}
                                </p>
                            </div>

                            <div className='flex justify-between'>
                                <p className='title'>Gross Weight</p>
                                <p className='value'>
                                    {formatNumber(item.grossWeight ?? 0)} kg
                                </p>
                            </div>
                        </div>
                    </Stack>
                ))}

            {docTitle === 'Commercial Invoice' && (
                <Stack direction='row' justifyContent='flex-end'>
                    <div className='w-full flex justify-between border-t border-b border-appcolorprimary py-4'>
                        Total amount :{' '}
                        <span className=''>
                            {formatCurrency(
                                totalAmount || 0,
                                data?.currencyCode
                            )}
                        </span>
                    </div>
                </Stack>
            )}

            {docTitle === 'Draft Certificate of Origin' && (
                <Stack direction='row' justifyContent='flex-end'>
                    <div className='w-full flex justify-between border-t border-b border-appcolorprimary py-4'>
                        Total Weight :{' '}
                        <span className=''>
                            {formatNumber(totalGrossWeight ?? 0)} Kg
                        </span>
                    </div>
                </Stack>
            )}

            {docTitle === 'Packing List' && (
                <div className='flex justify-end mt-8 '>
                    <Stack direction='column' width='100%'>
                        <div className='w-full flex justify-between border-t border-appcolorprimary pt-4 text-sm'>
                            Total Unit Qty:{' '}
                            <span className=' font-bold text-base'>
                                {formatNumber(totalUnitQuantity ?? 0)}
                            </span>
                        </div>

                        <div className='w-full flex justify-between border-appcolorprimary text-sm'>
                            Total net weight (kg):{' '}
                            <span className=' font-bold text-base'>
                                {formatNumber(totalNetWeight ?? 0)}
                            </span>
                        </div>

                        <div className='w-full flex justify-between border-appcolorprimary text-sm'>
                            Total gross weight (kg):{' '}
                            <span className=' font-bold text-base'>
                                {formatNumber(totalGrossWeight ?? 0)}
                            </span>
                        </div>

                        <div className='w-full flex justify-between border-b border-appcolorprimary pb-4 text-sm'>
                            Total volume (m³):{' '}
                            <span className=' font-bold text-base'>
                                {formatNumber(totalVolume || 0)}
                            </span>
                        </div>
                    </Stack>
                </div>
            )}

            {docTitle === 'Draft Certificate of Origin' ? (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='bottom-preview-content'
                    width='full'
                    justifyContent={'space-between'}
                    style={{
                        position: 'static',
                        marginTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0
                    }}
                >
                    <div
                        className='view-one space-y-2'
                        style={{ maxWidth: '100%' }}
                    >
                        <div>
                            <p className='titl'>Chamber Issue Date</p>
                            <p>
                                {moment(data?.chamberIssuedDate).format('ll') ||
                                    '--'}
                            </p>
                        </div>
                        <div>
                            <p className='titl'>
                                Chamber Name Of Authorized Signatory
                            </p>
                            <p>
                                {data?.chamberNameOfAuthorisedSignatory || '--'}
                            </p>
                        </div>
                        <div>
                            <p className='titl'>Chamber Signature</p>
                            <img src={`${signatureUrlBase64Chamber}`} alt='' />
                        </div>
                    </div>

                    <div
                        className='view-two space-y-2 mt-2'
                        style={{ maxWidth: '100%' }}
                    >
                        <div>
                            <p className='titl'>Chamber Place of Issue</p>
                            <p>{data?.chamberPlaceOfIssue || '--'}</p>
                        </div>
                        <div>
                            <p className='titl'>Place of Issue</p>
                            <p className=''>
                                {data?.exporterPlaceOfIssue || '--'}
                            </p>
                        </div>
                    </div>

                    <div
                        className='view-three space-y-2 mt-2'
                        style={{ maxWidth: '100%' }}
                    >
                        <div>
                            <p className='titl'>Issued Date</p>
                            <p className=''>
                                {moment(data?.exporterIssuedDate).format(
                                    'll'
                                ) || '--'}
                            </p>
                        </div>
                        <div>
                            <p className='titl'>Name of Authorized Signatory</p>
                            <p>
                                {data?.exporterNameOfAuthorisedSignatory ||
                                    '--'}
                            </p>
                        </div>
                        <div>
                            <p className='titl'>Signature</p>
                            <img src={`${signatureUrlBase64}`} alt='' />
                        </div>
                    </div>
                </Stack>
            ) : (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='bottom-preview-content'
                    width='full'
                    justifyContent={'space-between'}
                    style={{
                        position: 'static',
                        marginTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0
                    }}
                >
                    <div
                        className='view-one space-y-2'
                        style={{ maxWidth: '100%' }}
                    >
                        <div>
                            <p className='titl'>Bank Details</p>
                            <p>{data?.bankDetails || '--'}</p>
                        </div>
                        <div>
                            <p className='titl'>Additional Information</p>
                            <p>{data?.additionalInformation}</p>
                        </div>
                    </div>
                    <div
                        className='view-two space-y-2 mt-2'
                        style={{ maxWidth: '100%' }}
                    >
                        <div>
                            <p className='titl'>Place of Issue</p>
                            <p className=''>{data?.placeOfIssue || '--'}</p>
                        </div>
                        <div>
                            <p className='titl'>Signatory Company</p>
                            <p>{data?.signatoryCompany || '--'}</p>
                        </div>
                        {data?.stamp && (
                            <Stack direction='row' justifyContent='flex-start'>
                                <div className='totalView w-[250px]'>
                                    <p className='titl'>Exporter's Stamp</p>
                                    <div className='h-[50px] img'>
                                        <DocumentViewer
                                            fileUrl={`${REACT_APP_BASE_URL}/${data?.stamp.split(
                                                '/v1/'
                                            )[1]}`}
                                        />
                                    </div>
                                </div>
                            </Stack>
                        )}
                    </div>

                    <div
                        className='view-three space-y-2 mt-2'
                        style={{ maxWidth: '100%' }}
                    >
                        <div>
                            <p className='titl'>Due Date</p>
                            <p className=''>
                                {moment(data?.dueDate).format('ll') || '--'}
                            </p>
                        </div>
                        <div>
                            <p className='titl'>Name of Authorized Signatory</p>
                            <p>{data?.nameOfAuthorisedSignatory || '--'}</p>
                        </div>
                        <div>
                            <p className='titl'>Signature</p>
                            <img src={`${signatureUrlBase64}`} alt='' />
                        </div>
                    </div>
                </Stack>
            )}
        </PreviewContent>
    );
};

export default FormPreviewMobileTemplate;
